export class PlanningTrafoDtosFrontend{
    gridElementName: string;
    existingMVorSSBGridElementId: number;
    trafoRatio: number;
    trafoSize_kVA: number;
}